import { render, staticRenderFns } from "./ListNotificationPage.vue?vue&type=template&id=6a469518"
import script from "./ListNotificationPage.vue?vue&type=script&lang=js"
export * from "./ListNotificationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports